
import { EventBus, TypeEventBus } from '../../../../core/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CentroidIndicator extends Vue {
  @Prop({ default: null }) centroidInfo!: { lat: number; lng: number } | null;
  /** `false` si ni `centroid` de `/ranch/` ni la `redirect_url` traen un centroide válido: se muestra 0,0 y el aviso. */
  @Prop({ type: Boolean, default: false }) centroidIsValid!: boolean;
  copied: boolean = false
  timer: number | null = null

  get hasCentroid() {
    return this.centroidIsValid &&
      !!(this.centroidInfo && Number.isFinite(this.centroidInfo.lat) && Number.isFinite(this.centroidInfo.lng));
  }

  get displayLat() {
    return this.hasCentroid && this.centroidInfo ? this.centroidInfo.lat : 0;
  }

  get displayLng() {
    return this.hasCentroid && this.centroidInfo ? this.centroidInfo.lng : 0;
  }

  fmt(n: number) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 6 }).format(n);
  }

  async copyCoords() {
    const text = `${this.displayLat}, ${this.displayLng}`

    try {
      await navigator.clipboard.writeText(text)
      EventBus.$emit(TypeEventBus.SHOW_MESSAGE, 'Coordenadas copiadas', 'success')
      this.copied = true
      if (this.timer) clearTimeout(this.timer)
      this.timer = window.setTimeout(() => {
        this.copied = false
      }, 2000)
    } catch (e) {
      console.error(e)
    }
  }
}
